;(function(global) {

  // Run all Slick Sliders
  // ====================================================================================================
  function slickSliders() {
    const next = '<button type="button" class="slick-next">'+theme.icons.chevronRight+'</button>';
    const prev = '<button type="button" class="slick-prev">'+theme.icons.chevronLeft+'</button>';

    $('[data-model="slick-slider"]:not(.slick-initialized)').slick({
      nextArrow: next,
      prevArrow: prev
    });

    if ($(window).width() >= 767) {
      $('[data-model="slick-slider-desktop"]:not(.slick-initialized)').slick({
        nextArrow: next,
        prevArrow: prev
      });
      $('[data-model="slick-slider-mobile"].slick-initialized').slick('unslick');
    } else {
      $('[data-model="slick-slider-mobile"]:not(.slick-initialized)').slick({
        nextArrow: next,
        prevArrow: prev
      });
      $('[data-model="slick-slider-desktop"].slick-initialized').slick('unslick');
    }
  };

  // Run after load page
  // ====================================================================================================
  $(document).ready(function() {
    slickSliders();
  });

  // Run after load section
  // ====================================================================================================
  $(document).on('shopify:section:load', function(event) {
    slickSliders();
  });

}(window));